@if ({
  steps: steps$ | async,
  activeStepIndex: activeStepIndex$ | async
  }; as type) {
  <div class="container">
    <div class="row justify-content-center">
      @for (step of type.steps; track step; let i = $index) {
        <div class="d-flex justify-content-center px-0 mx-0 col-2 c-col-2">
          <div class="registration-step-index-divider" [ngClass]="getStepIndexLeftDividerClass(step.index)"></div>
          @if (step.index === type.activeStepIndex) {
            <cx-icon [type]="numberToIconRecord[step.index].circleFilled" [ngClass]="getStepHighlightClass(step.index, type.activeStepIndex)"></cx-icon>
          } @else {
            @if (step.index > type.activeStepIndex) {
              <cx-icon [type]="numberToIconRecord[step.index].circleOutline" [ngClass]="getStepHighlightClass(step.index, type.activeStepIndex)"></cx-icon>
            } @else {
              <cx-icon [type]="iconType.CHECK_CIRCLE_FILLED_SUCCESS" [ngClass]="getStepHighlightClass(step.index, type.activeStepIndex)"></cx-icon>
            }
          }
          <div class="registration-step-index-divider" [ngClass]="getStepIndexRightDividerClass(step.index, type.steps.length)"></div>
        </div>
      }
    </div>
    <div class="d-none d-md-flex row justify-content-center">
      @for (step of type.steps; track step) {
        <div class="d-flex justify-content-center text-center col-2 c-col-2">
          <span class="registration-step-title u-font-bold" [ngClass]="getStepHighlightClass(step.index, type.activeStepIndex)">
            {{ step.title }}
          </span>
        </div>
      }
    </div>
  </div>
}
